import { type context_engine } from "@dropbox/api-v2-client/types";
import { type AvailableModels, type ModelInfo } from "../types";

export const convertToAvailableModels = (
  response: context_engine.ListAvailableModelsResponse,
): AvailableModels => {
  return {
    models: (response.models || []).map(convertModelInfo),
  };
};

const convertModelInfo = (model: context_engine.ModelInfo): ModelInfo => {
  return {
    id: model.id!,
    displayName: model.display_name!,
    description: model.description!,
    isCertified: model.is_certified!,
  };
};
